export default "__VITE_ASSET__BgZyTdzM__"